import { render, staticRenderFns } from "./NumberInfoModal.component.vue?vue&type=template&id=4906e44a&scoped=true&"
import script from "./NumberInfoModal.component.vue?vue&type=script&lang=js&"
export * from "./NumberInfoModal.component.vue?vue&type=script&lang=js&"
import style0 from "./NumberInfoModal.component.vue?vue&type=style&index=0&id=4906e44a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4906e44a",
  null
  
)

export default component.exports